// @ts-check

/** Pure helpers for the Inventory "Count" tab: variance display and the bulk-count payload. */

/**
 * Counted minus system stock, or null while the field is still blank.
 * @param {number} systemStock
 * @param {string | number | undefined} counted
 */
export function variance(systemStock, counted) {
  if (counted === '' || counted === undefined || counted === null) return null;
  return Number(counted) - systemStock;
}

/** Rows that actually have something typed in, keyed by variant_id -> typed text. */
export function countedRows(rows, counts) {
  return rows.filter((row) => counts[row.variant_id] !== undefined && counts[row.variant_id] !== '');
}

/**
 * Body for POST /api/admin/inventory/count.
 * @param {{rows: any[], counts: Record<string, string>, salesEventId: string, notes: string}} args
 */
export function buildCountPayload({ rows, counts, salesEventId, notes }) {
  const trimmed = notes.trim();
  return {
    sales_event_id: salesEventId,
    entries: countedRows(rows, counts).map((row) => ({
      variant_id: row.variant_id,
      counted_quantity: Number(counts[row.variant_id]),
    })),
    notes: trimmed === '' ? null : trimmed,
  };
}
